export default __webpack_public_path__ + "static/media/DSC06107.e83f0513.jpg";